<template>
  <div>
    <app-spinner v-if="!is_loaded"/>
    <div v-else class="driver">
      <div class="driver__wrapper">
        <app-cells>
          <h1 class="title">
            {{ driver.first_name }} {{ driver.last_name }}
          </h1>
        </app-cells>
        <div class="info-cards">
          <div class="info-cards__card">
            <div class="info-cards__row">
              <div class="info-cards__row-item info-cards__row-item--full">
                <span>Total ordered:</span><span>{{ driver.total_ordered.toLocaleString() }} TSh</span>
              </div>
            </div>
            <div class="info-cards__row">
              <div class="info-cards__row-item info-cards__row-item--full">
                <span>Total unpaid:</span><span>{{ driver.total_unpaid.toLocaleString() }} TSh</span>
              </div>
            </div>
            <div class="info-cards__row">
              <div class="info-cards__row-item info-cards__row-item--full">
                <span>Total paid:</span><span>{{ driver.total_paid.toLocaleString() }} TSh</span>
              </div>
            </div>
          </div>
        </div>
        <div class="accordion">
          <app-cells :indent="false">
            <h2 class="title">Personal & Contact details</h2>
            <app-button
              @click.native="onCheckForm"
              :disabled="$v.form.$error"
              ref="submit"
              size="small"
            >
              Save
            </app-button>
          </app-cells>
          <div class="accordion__body">
            <form class="accordion__form">
              <div class="accordion__row accordion__row--type-200">
                <app-form-group label="First name" label-for="first_name" required>
                  <app-input
                    v-model="form.first_name"
                    @change.native="$v.form.first_name.$touch()"
                    :error="$v.form.first_name.$error"
                    id="first_name"
                    placeholder="First name"
                    name="first_name"
                  />
                  <template #error>
                    <div v-if="$v.form.first_name.$dirty && !$v.form.first_name.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Last name" label-for="last_name">
                  <app-input
                    v-model="form.last_name"
                    id="last_name"
                    placeholder="Last name"
                    name="last_name"
                  />
                </app-form-group>
                <app-form-group label="Phone number">
                  <app-phone
                    v-model="form.phone"
                    placeholder="+7 499 113 28 00"
                  />
                </app-form-group>
                <app-form-group label="Other communications" class="form-group--center">
                  <app-cells :indent="false">
                    <app-checkbox v-model="form.phone_telegram" label="Telegram" :readonly="!form.phone"/>
                    <app-checkbox v-model="form.phone_whatsapp" label="Whatsapp" :readonly="!form.phone"/>
                  </app-cells>
                </app-form-group>
              </div>
              <div class="accordion__row accordion__row--type-200">
                <app-form-group label="Car model" required>
                  <app-select
                    v-model="form.car_model"
                    :reduce="item => item.id"
                    :options="cars_options"
                    :clearable="false"
                    placeholder="Car model"
                    :error="$v.form.car_model.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.car_model.$dirty && !$v.form.car_model.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Plate number" label-for="plate_number" required>
                  <app-input
                    v-model="form.plate_number"
                    @change.native="$v.form.plate_number.$touch()"
                    :error="$v.form.plate_number.$error"
                    id="plate_number"
                    placeholder="Plate number"
                    name="plate_number"
                  />
                  <template #error>
                    <div v-if="$v.form.plate_number.$dirty && !$v.form.plate_number.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Additional phone">
                  <app-phone
                    v-model="form.additional_phone"
                    placeholder="+7 499 113 28 00"
                  />
                </app-form-group>
                <app-form-group label="Additional communications" class="form-group--center">
                  <app-cells :indent="false">
                    <app-checkbox v-model="form.additional_phone_telegram" label="Telegram"
                                  :readonly="!form.additional_phone"/>
                    <app-checkbox v-model="form.additional_phone_whatsapp" label="Whatsapp"
                                  :readonly="!form.additional_phone"/>
                  </app-cells>
                </app-form-group>
              </div>
              <div class="accordion__row accordion__row--type-200">
                <app-form-group label="Supplier" required>
                  <app-select
                    @search="onSupplierSearch"
                    @input="onSupplierSelected"
                    v-model="form.supplier"
                    :options="supplier_options"
                    :clearable="false"
                    :display-field="option => `${option.trade_name} ${option.tin ? `(TIN: ${option.tin})` : ''}`"
                    label="trade_name"
                    placeholder="Supplier"
                    :error="$v.form.supplier.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.supplier.$dirty && !$v.form.supplier.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Payment method" required>
                  <app-select
                    v-model="form.supplier_payment_method"
                    :options="form.supplier?.payment_methods"
                    :reduce="item => item.id"
                    label="public_name"
                    :clearable="false"
                    :searchable="false"
                    placeholder="Payment method"
                    :readonly="!form.supplier"
                    :error="$v.form.supplier_payment_method.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.supplier_payment_method.$dirty && !$v.form.supplier_payment_method.required">Required field</div>
                  </template>
                </app-form-group>
              </div>
            </form>
          </div>
        </div>
      </div>
      <app-cells><h2 class="title">List of transfers</h2></app-cells>
      <app-cells>
        <app-input
          @input.native="onListSearch"
          v-model="search"
          class="input--300"
          type="search"
          placeholder="Search by name"
          name="search"
        />
        <app-filters
          v-model="filter"
          :filters="filters"
          name="filterHall"
          @change="onFilterChange"
        />
      </app-cells>
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        class="table-default"
        :class="{ 'table-default--loading': table_preloader }"
      >
        <template #h__select>
          <label
            v-if="table.items.length && table.items.some(item => !item.invoice)"
            class="checkbox checkbox--table"
          >
            <input
              v-model="checked_all"
              type="checkbox"
              name="checked_all"
            />
            <span class="checkbox__checkmark"></span>
          </label>
        </template>
        <template #h__name>
          <div class="table-default__left">Name</div>
        </template>
        <template #h__from>
          <div class="table-default__left">From</div>
        </template>
        <template #h__to>
          <div class="table-default__left">To</div>
        </template>
        <template #select="{ row }">
          <label v-if="!row.invoice" class="checkbox checkbox--table">
            <input
              v-model="checked_items"
              type="checkbox"
              :value="row"
            />
            <span class="checkbox__checkmark"></span>
          </label>
        </template>
        <template #price="{ row }">{{ row.cost.toLocaleString() }} TSh</template>
        <template #date="{ row }">{{ dateFormat(row.transfer.pick_up_date) }} {{ row.transfer.pick_up_time }}</template>
        <template #name="{ row }">
          <div class="table-default__svg-text">
            <span v-html="row.transfer.type.icon"></span>
            {{ row.transfer.name }} ({{ row.transfer.pax }})
          </div>
        </template>
        <template #from="{ row }">
          <div class="table-default__left">{{ row.transfer.pick_up_point.short_name }}</div>
        </template>
        <template #to="{ row }">
          <div class="table-default__left">
            {{ row.transfer.points[row.transfer.points.length - 1].location.short_name }}
          </div>
        </template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPagination"
            v-if="pagination.pages > 1"
            v-model="pagination.page"
            :page-count="pagination.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination.count" :count="table.items.length" :page="pagination.page"/>
      </app-cells>
      <app-cells><h2 class="title">Invoices</h2></app-cells>
      <v-client-table
        :data="table_invoices.items"
        :columns="table_invoices.columns"
        :options="table_invoices.options"
        class="table-default"
        :class="{ 'table-default--loading': table_invoices_preloader }"
      >
        <template #h__supplier><div class="table-default__left">Supplier</div></template>
        <template #h__responsible><div class="table-default__left">Responsible</div></template>
        <template #date="{ row }">{{ dateFormat(row.supplier_invoice.date) }}</template>
        <template #supplier="{ row }">
          <div class="table-default__left">
            <router-link
              :to="{ name: 'administrative-suppliers-detail-purchases', params: { id: row.supplier_invoice.supplier.id } }"
              class="table-default__link-inline"
            >
              {{ row.supplier_invoice.supplier.legal_name }}
            </router-link>
          </div>
        </template>
        <template #responsible="{ row }"><div class="table-default__left">{{ row.responsible?.full_name || '-' }}</div></template>
        <template #amount="{ row }">
          {{ amountFormat(row.supplier_invoice.amount_total) }} {{ row.supplier_invoice.currency.code }}
        </template>
        <template #invoice_number="{ row }">{{ row.supplier_invoice.invoice_number || '-' }}</template>
        <template #payment_method="{ row }">{{ row.supplier_invoice.supplier_payment_method.payment_method.name || '-' }}</template>
        <template #account="{ row }">
          <template v-if="row.supplier_invoice.supplier_payment_method.payment_method.code === 'bank'">
            <template v-if="row.supplier_invoice.supplier_payment_method.bank_account">
              {{ row.supplier_invoice.supplier_payment_method.bank_account.account_number }}<br>{{ row.supplier_invoice.supplier_payment_method.bank_account.bank.short_name }}
            </template>
            <template v-else>-</template>
          </template>
          <template v-else-if="row.supplier_invoice.supplier_payment_method.payment_method.code === 'mobile'">
            <template v-if="row.supplier_invoice.supplier_payment_method.mobile_account">
              {{ row.supplier_invoice.supplier_payment_method.mobile_account.account_number }}<br>{{ row.supplier_invoice.supplier_payment_method.mobile_account.provider.name }}
            </template>
            <template v-else>-</template>
          </template>
          <template v-else-if="row.supplier_invoice.supplier_payment_method.payment_method.code === 'gepg'">
            <template v-if="row.supplier_invoice.gepg_number">{{ row.gepg_number }}</template>
            <template v-else>-</template>
          </template>
          <template v-else>-</template>
        </template>
        <template #payment_plans="{ row }">
          <span
            :style="{ 'backgroundColor': row.supplier_invoice.payment_status === 'unpaid' ? '#e85c20' : row.supplier_invoice.payment_status === 'paid' ? '#77b017' : '#439ad1' }"
            class="status-tag"
          >
            {{ row.supplier_invoice.payment_status === 'unpaid' ? 'Unpaid' : row.supplier_invoice.payment_status === 'paid' ? 'Paid' : amountFormat(row.supplier_invoice.paid_amount) }}
          </span>
        </template>
        <template #attachment="{ row }">
          <div class="table-default__controls">
            <a
              :href="row.attachment?.file"
              target="_blank"
              :class="{'table-default__disabled': !row.attachment}"
            >
              <img
                src="@/assets/img/snacks-link.svg"
                alt="Attachment"
              >
            </a>
          </div>
        </template>
        <template #controls="{ row }">
          <div class="table-default__controls">
            <button @click="onShowDeleteInvoiceModal(row.id)" type="button">
              <img src="@/assets/img/delete-table-icon.svg" alt="Delete">
            </button>
          </div>
        </template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPaginationInvoices"
            v-if="pagination_invoices.pages > 1"
            v-model="pagination_invoices.page"
            :page-count="pagination_invoices.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination_invoices.count" :count="table_invoices.items.length" :page="pagination_invoices.page" />
      </app-cells>
      <div class="flying-block" :class="{ 'flying-block--show': is_show_flying_block }">
        <div class="flying-block__text">
          Selected transfers:
          <template v-if="checked_items.length"><span>{{ checked_items.length }}</span> ({{ checkedSum ? `${amountFormat(checkedSum)} TZS` : '' }})</template>
        </div>
        <app-button @click.native="onShowModalRequestPayment">Request payment</app-button>
      </div>
    </div>
    <modal
      name="request_payment_modal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      draggable=".popup__title"
      class="modal-not-overflow"
    >
      <div class="popup">
        <button @click="$modal.hide('request_payment_modal')" class="popup__close" type="button"></button>
        <div class="popup__title">Request payment for {{ amountFormat(checkedSum) }} TZS</div>
        <div class="popup__body">
          <app-form-group label="Due date" required>
            <app-date-picker
              v-model="due_date"
              placeholder="Date"
              :error="$v.due_date.$error"
            />
            <template #error>
              <div v-if="$v.due_date.$dirty && !$v.due_date.required">Required field</div>
            </template>
          </app-form-group>
          <app-cells :indent="false" position="center">
            <app-button @click.native="onCheckRequestPayment" ref="request_payment">Request</app-button>
          </app-cells>
        </div>
      </div>
    </modal>
    <modal
      name="delete_modal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('delete_modal')" class="popup__close" type="button"></button>
        <div class="popup__title popup__title--flex">
          <img src="@/assets/img/warning-round-icon.svg" alt="">
          Delete invoice
        </div>
        <div class="popup__body">
          <div class="popup__subt">Are you sure you want to delete this invoice?</div>
          <app-cells position="center" :indent="false">
            <app-button @click.native="$modal.hide('delete_modal')" theme="dark">Cancel</app-button>
            <app-button @click.native="onDeleteInvoice" ref="deleteInvoice">Yes</app-button>
          </app-cells>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  getAdministrativeSuppliers,
  getCarManagementCarModels,
  getFinanceAccounts,
  getTransfersTaxi,
  getTransfersTaxiDrivers,
  patchTransfersTaxiDrivers,
  postTransfersTaxiDriversInvoices,
  getTransfersTaxiDriversInvoices,
  deleteTransfersTaxiDriversInvoices
} from '@/http'
import { format, parse, parseISO } from 'date-fns'
import { required } from 'vuelidate/lib/validators'
import debounce from 'lodash/debounce'

export default {
  name: 'TaxiDriversDetail',
  data() {
    return {
      is_loaded: false,
      form: {},
      driver: {},
      cars_options: [],
      supplier_options: [],
      table: {
        items: [],
        columns: [
          'select',
          'price',
          'date',
          'name',
          'from',
          'to',
        ],
        options: {
          headings: {
            'select': '',
            'price': 'Price',
            'date': 'Date',
            'name': 'Name',
            'from': 'From',
            'to': 'To',
          },
          pagination: {show: false},
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false,
        },
      },
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_preloader: false,
      table_invoices: {
        items: [],
        columns: [
          'date',
          'supplier',
          'amount',
          'invoice_number',
          'responsible',
          'payment_method',
          'account',
          'payment_plans',
          'attachment',
          'controls'
        ],
        options: {
          headings: {
            'date': 'Date',
            'supplier': 'Supplier',
            'amount': 'Amount',
            'invoice_number': 'Invoice number',
            'responsible': 'Responsible',
            'payment_method': 'Payment method',
            'account': 'Account',
            'payment_plans': 'Payment',
            'attachment': 'Attachment',
            'controls': '',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_invoices: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_invoices_preloader: false,
      invoice_to_action: null,
      search: '',
      filter: 'false',
      filters: [
        {value: 'false', label: 'Pending'},
        {value: 'true', label: 'Invoiced'},
        {value: '', label: 'All'},
      ],
      account_options: [],
      checked_all: false,
      checked_items: [],
      is_show_flying_block: false,
      due_date: null,
    }
  },
  validations: {
    due_date: {required},
    form: {
      first_name: {required},
      car_model: {required},
      plate_number: {required},
      supplier: {required},
      supplier_payment_method: {required},
    },
  },
  computed: {
    checkedSum() {
      if (this.checked_items.length) {
        return this.checked_items
          .map(item => item.cost)
          .reduce((a, b) => {
            return a + b
          }, 0)
      } else {
        return ''
      }
    },
  },
  watch: {
    checked_all(value) {
      if (value) {
        this.table.items.forEach(item => {
          if (!this.checked_items.map(item => item.id).includes(item.id) && !item.invoice) this.checked_items.push(item)
        })
      } else {
        this.checked_items = []
      }
    },
    checked_items(value) {
      this.is_show_flying_block = value.length > 0
      if (!this.checked_items.length) this.checked_all = false
    },
  },
  created() {
    Promise.all([
      getTransfersTaxiDrivers(this.$route.params.id),
      this.fetchItems(),
      this.fetchItemsInvoices(),
    ])
      .then(res => {
        this.form = {...res[0].data}
        this.driver = res[0].data

        this.is_loaded = true
      })
    getCarManagementCarModels().then(res => {
      this.cars_options = res.data
    })
    getFinanceAccounts().then(response => {
      this.account_options = response.data
    })
  },
  methods: {
    async fetchItems() {
      this.table_preloader = true
      const response = await getTransfersTaxi({
        page: this.pagination.page,
        page_size: 20,
        search: this.search,
        taxi_driver: this.$route.params.id,
        invoice: this.filter,
        ordering: this.filter === 'false' ? 'transfer.pick_up_date,transfer.pick_up_time' : '',
      })
      this.table.items = response.data.results
      this.pagination.pages = response.data.pages
      this.pagination.count = response.data.count
      this.table_preloader = false
    },
    async fetchItemsInvoices() {
      const response = await getTransfersTaxiDriversInvoices(this.$route.params.id, {
        page: this.pagination_invoices.page,
        page_size: 20,
      })
      this.table_invoices.items = response.data.results
      this.pagination_invoices.pages = response.data.pages
      this.pagination_invoices.count = response.data.count
      this.table_invoices_preloader = false
    },
    onFilterChange() {
      this.fetchItems()
    },
    onSupplierSelected() {
      this.form.supplier_payment_method = null
    },
    dateTimeFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy HH:mm') : '-'
    },
    onCheckForm() {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.submit.preload = true
      patchTransfersTaxiDrivers(this.$route.params.id, this.normalizeForm())
        .finally(() => {
          this.$refs.submit.preload = false
        })
        .then(res => {
          this.form = {...res.data}
          this.driver = res.data
          this.$notify({
            type: 'success',
            title: 'Taxi driver saved',
          })
        })
    },
    normalizeForm() {
      const form = {...this.form}

      if (form.car_model && typeof form.car_model !== 'number') form.car_model = form.car_model.id
      form.supplier = form.supplier.id
      return form
    },
    onCheckRequestPayment() {
      this.$v.due_date.$touch()
      if (this.$v.due_date.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.$refs.request_payment.preload = true
        postTransfersTaxiDriversInvoices(
          this.$route.params.id,
          {due_date: this.due_date, transfers: this.checked_items.map(item => item.id)}
        )
          .then(() => {
            this.fetchItems()
            this.fetchItemsInvoices()
            this.$modal.hide('request_payment_modal')
            this.checked_items = []
          })
          .catch(() => { this.$refs.request_payment.preload = false })
      }
    },
    onShowModalRequestPayment() {
      this.due_date = null
      this.$v.due_date.$reset()
      this.$modal.show('request_payment_modal')
    },
    dateFormat(date) {
      return date ? format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy') : '-'
    },
    amountFormat(amount) {
      return amount ? new Intl.NumberFormat('ru-RU').format(amount) : '-'
    },
    clientTableList(clients) {
      let result = ''

      for (const key in clients) {
        result += `${clients[key].first_name} ${clients[key].last_name}<br>`
      }
      return result
    },
    onClickPagination(page) {
      this.pagination.page = page
      this.fetchItems()
    },
    onClickPaginationInvoices() {
      this.pagination_invoices.page = page
      this.fetchItemsInvoices()
    },
    onShowDeleteInvoiceModal(id) {
      this.invoice_to_action = id
      this.$modal.show('delete_modal')
    },
    onDeleteInvoice() {
      this.$refs.deleteInvoice.preload = true
      deleteTransfersTaxiDriversInvoices(this.$route.params.id, this.invoice_to_action)
        .then(() => {
          this.fetchItemsInvoices()
          this.$notify({
            type: 'success',
            title: 'Invoice deleted',
          })
          this.$modal.hide('delete_modal')
        })
        .catch(() => { this.$refs.deleteInvoice.preload = false })
    },
    onListSearch() {
      this.searchList(this)
    },
    searchList: debounce(vm => {
      this.pagination.page = 1
      vm.fetchItems()
    }, 350),
    onSupplierSearch(search, loading) {
      loading(true)
      this.searchSupplier(loading, search, this)
    },
    searchSupplier: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.supplier_options = []
      } else {
        getAdministrativeSuppliers({search}).then(response => {
          vm.supplier_options = response.data
          loading(false)
        })
      }
    }, 350),
  },
}
</script>

<style lang="sass" scoped>
.driver__wrapper
  max-width: 950px

.slide-enter-active
  transition-duration: 0.3s
  transition-timing-function: ease-in

.slide-leave-active
  transition-duration: 0.3s
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1)

.slide-enter-to, .slide-leave
  max-height: 768px
  overflow: hidden

.slide-enter, .slide-leave-to
  overflow: hidden
  max-height: 0

.slide-small-enter-active
  transition-duration: 0.3s
  transition-timing-function: ease-in

.slide-small-leave-active
  transition-duration: 0.3s
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1)

.slide-small-enter-to, .slide-small-leave
  max-height: 147px
  overflow: hidden

.slide-small-enter, .slide-small-leave-to
  overflow: hidden
  max-height: 0
</style>
